module.exports = __webpack_public_path__ + "media/recipes/98-4f6a00ba.png";